import { HttpErrorResponse } from '@angular/common/http';
import { ApiNamesEnum } from 'src/app/utils/enums';
import { CerberusErrorCodesEnum, NephilimErrorCodesEnum, HuginnErrorCodesEnum } from 'src/app/utils/enums/error-codes';
import { WolandErrorCodesEnum } from 'src/app/utils/enums/error-codes/woland-error-codes.enum';

export class ExtractedError {
    constructor(error: HttpErrorResponse, apiName: ApiNamesEnum, errorCode: CerberusErrorCodesEnum | NephilimErrorCodesEnum | HuginnErrorCodesEnum | WolandErrorCodesEnum|  null){
        this.error = error;
        this.apiName = apiName;
        this.errorCode = errorCode;
    }

    error: HttpErrorResponse;
    apiName: ApiNamesEnum;
    errorCode: CerberusErrorCodesEnum | NephilimErrorCodesEnum | HuginnErrorCodesEnum | WolandErrorCodesEnum | null;
}